module.exports = __webpack_public_path__ + "img/20170704_135648_092.9aad713b.jpg";